import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { base64ToFile, ImageCroppedEvent } from 'ngx-image-cropper';
import { finalize } from 'rxjs/operators';
import { SetupRequest } from 'src/app/models/setup-request.model';
import { AlertService } from 'src/app/service/alert.service';
import { AvatarUploadServiceService } from 'src/app/service/http-services/avatar-upload-service.service';
import { DisordersService } from 'src/app/service/http-services/disorders.service';
import { UserService } from 'src/app/service/http-services/user.service';

export class DisordersSetup {
  public isSelected: boolean = false
  public hide: boolean = false
  constructor(
    public key: string,
    public value: string,
  ) { }
}

@Component({
  selector: 'app-user-setup',
  templateUrl: './user-setup.component.html',
  styleUrls: ['./user-setup.component.css']
})
export class UserSetupComponent implements OnInit {

  public showCard = "card1";
  //disorders card
  disordersSetup: DisordersSetup[] = []
  isSetupLoading: boolean = false;

  //avatar card
  file!: any
  isAvatarLoading: boolean = false;
  imageChangedEvent: any = '';
  croppedImage: any;
  showCropper: boolean = false;

  //status card
  @ViewChild('statusInput') private statusInput!: ElementRef;
  statusLoad: boolean = false;

  uploadForm: FormGroup = new FormGroup({
    file: new FormControl(null, [Validators.required])
  })

  constructor(
    private disorderService: DisordersService,
    private router: Router,
    private alertService: AlertService,
    private userService: UserService,
    private avatarService: AvatarUploadServiceService
  ) { }

  ngOnInit(): void {
  }

  isShowCard(card: string): boolean {
    return this.showCard === card;
  }

  showChoiceCard() {
    this.disorderService.getEnumDisorders().subscribe(rsp => {
      rsp.forEach(d => {
        this.disordersSetup.push(new DisordersSetup(d.key, d.value));
      })
    })
    this.showCard = "card2";
  }

  mark(disorder: DisordersSetup) {
    let myDisorder = this.disordersSetup.find(x => x.key === disorder.key)!;
    myDisorder.isSelected = !myDisorder.isSelected
  }

  setUpUser() {
    this.isSetupLoading = true;
    this.disorderService.saveSetup(new SetupRequest(this.getSelectedDisorders())).pipe(
      finalize(() => this.isSetupLoading = false)
    )
      .subscribe(rsp => {
        this.userService.saveUserStorage(rsp);
        this.showCard = "card3"
      },
        err => {
          this.alertService.error(err.error.message)
        }
      )
  }

  getSelectedDisorders(): string[] {
    return this.disordersSetup
      .filter(x => x.isSelected == true)
      .map(x => x.key);
  }

  getUser() {
    return this.userService.getUserStorage();
  }

  handleFileInput(file: any) {
    this.imageChangedEvent = file;
    this.showCropper = true;
  }

  uploadAvatar() {
    this.isAvatarLoading = true;
    this.avatarService.uploadAvatar(this.file).pipe(
      finalize(() => {
        this.isAvatarLoading = false
        this.showCard = "card4"
      })
    )
      .subscribe(rsp => {
        let userWithAvatar = this.userService.getUserStorage();
        userWithAvatar.avatarId = rsp;
        this.userService.saveUserStorage(userWithAvatar);
        this.router.navigate(["chat"])
      });
  }

  skipAvatar() {
    this.showCard = "card4"
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.file = new File([base64ToFile(this.croppedImage)], "avatar.jpeg");
  }

  filterDisorders(event: any) {
    let searchValue: string = event.target.value;
    this.disordersSetup.forEach(d => {
      if (d.value.toLowerCase().includes(searchValue.toLowerCase())) {
        d.hide = false;
      }
      else {
        d.hide = true;
      }
    })
  }

  getStatusMessage(): string {
    if (this.statusInput) {
      return this.statusInput.nativeElement.value;
    }
    return ""
  }

  setStatusMessage() {
    this.statusLoad = true;
    let val: string = this.statusInput.nativeElement.value;
    this.userService.setStatusMessage(val).pipe(
      finalize(() => {
        this.statusLoad = false;
      })
    )
      .subscribe(() => {
        let userWithStatus = this.userService.getUserStorage();
        userWithStatus.statusMessage = val;
        this.userService.saveUserStorage(userWithStatus);
        this.router.navigate(["chat"])
      },
      err => {
        let errBody = JSON.parse(err.error);
        this.alertService.error(errBody.message)
      })
  }

  skipStatusMessage(){
    this.router.navigate(["chat"])
  }

}
